import React from 'react'

export function HelpIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx={12} cy={12} r={10} stroke='currentColor' strokeWidth={2} />
      <path
        d='M9.5 9.077a3.104 3.104 0 011.348-1.648 3.07 3.07 0 013.926.678c.47.561.727 1.272.726 2.006 0 3.11-3.429 2.22-3.429 4.887'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx={12} cy={18} r={1} fill='currentColor' />
    </svg>
  )
}
